import { withTrackedReducer } from '@angular-architects/ngrx-toolkit';
import {
  INITIAL_OFFSHORE_REPORT_STATE,
  OffshoreReportState,
} from '@navstation-portal/reporting/data-model/offshore-report';
import { authEvents } from '@navstation-portal/shared/data-access/auth';
import { signalStoreFeature, type } from '@ngrx/signals';
import { on } from '@ngrx/signals/events';
import { offshoreReportEvents } from './offshore-report.events';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withOffshoreReportReducer<_>() {
  return signalStoreFeature(
    type<{ state: OffshoreReportState }>(),
    withTrackedReducer(
      on(authEvents.logoutSuccess, () => INITIAL_OFFSHORE_REPORT_STATE),
      on(offshoreReportEvents.reset, () => INITIAL_OFFSHORE_REPORT_STATE),
      on(offshoreReportEvents.setFormConfig, ({ payload }) => ({
        formConfig: payload,
      })),
      on(offshoreReportEvents.fetchReport, () => ({
        fetchingReport: true,
      })),
      on(offshoreReportEvents.fetchReportSuccess, (report) => ({
        fetchingReport: false,
      })),
      on(offshoreReportEvents.fetchReportFailed, (error) => ({
        fetchingReport: false,
      })),
      on(offshoreReportEvents.createReport, () => ({
        creatingReport: true,
      })),
      on(offshoreReportEvents.createReportSuccess, (report) => ({
        creatingReport: false,
      })),
      on(offshoreReportEvents.createReportFailed, (error) => ({
        creatingReport: false,
      })),
      on(offshoreReportEvents.saveReport, () => ({
        savingReport: true,
      })),
      on(offshoreReportEvents.saveReportSuccess, (report) => ({
        savingReport: false,
      })),
      on(offshoreReportEvents.saveReportFailed, (error) => ({
        savingReport: false,
      }))
    )
  );
}
